import { Swiper } from "swiper";
import { A11y, EffectFade, Pagination } from "swiper/modules";

class Slideshow {
  private slider: HTMLElement;
  private paginationEl: HTMLElement;
  private pm: any;

  constructor(slideshow: HTMLElement) {
    this.slider = slideshow.querySelector(".swiper") as HTMLElement;
    this.paginationEl = slideshow.querySelector(
      ".swiper-pagination"
    ) as HTMLElement;
    this.pm = (window as any).personalizationManager;

    if (this.pm) {
      this.pm.addPersonalizedContentLoaded(() => {
        this.init();
      });
    } else {
      this.init();
    }
  }

  init(): void {
    const swiper = new Swiper(this.slider, {
      modules: [Pagination, A11y, EffectFade],
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: this.paginationEl,
        type: "bullets",
        clickable: true,
        renderBullet: (index: number, className: string) => {
          const title = this.slider
            .querySelector(
              `.swiper-slide:nth-child(${index + 1}) .display-title`
            )
            ?.textContent.trim() as string;
          return `<button type="button" class="${className}">${title}</button>`;
        },
      },
      on: {
        init: (s) => this.updateA11y(s),
        slideChangeTransitionEnd: (s) => this.updateA11y(s),
      },
    });

    // Sync visual slide state when VoiceOver (or any AT) moves focus into a
    // non-active slide via flick/swipe gesture. iOS VoiceOver bypasses
    // aria-hidden and can land focus inside hidden slides; this listener
    // ensures the carousel advances to match the focused slide.
    this.slider.addEventListener("focusin", (e: FocusEvent) => {
      const slide = (e.target as HTMLElement).closest<HTMLElement>(".swiper-slide");
      if (!slide) return;
      const index = swiper.slides.findIndex((s) => s === slide);
      if (index !== -1 && index !== swiper.activeIndex) {
        swiper.slideTo(index);
      }
    });
  }

  private updateA11y(swiper: Swiper): void {
    swiper.slides.forEach((slide: HTMLElement, i: number) => {
      const isActive = i === swiper.activeIndex;
      if (isActive) {
        slide.removeAttribute("aria-hidden");
      } else {
        slide.setAttribute("aria-hidden", "true");
      }
      slide.querySelectorAll<HTMLAnchorElement>("a").forEach((a) => {
        if (isActive) {
          a.removeAttribute("tabindex");
        } else {
          a.setAttribute("tabindex", "-1");
        }
      });
    });
  }
}

document.querySelectorAll("[slideshow]").forEach((slider) => {
  new Slideshow(slider as HTMLElement);
});
